import React from "react";
import {Cell} from "../../elements/Tables";
import {subduedTextColour} from "../../../style/styleConsts";
import styled from "styled-components";

const NameCell = styled(Cell)`

`;

export const ClarifierCell = styled.div`
    color: ${subduedTextColour};
    font-size: 12px;
`;

export const GroupingNameCell = styled(Cell)`
`;

const RedactedName = styled(GroupingNameCell)`
    color: rgba(112, 108, 103, 0.5);
`;

const GroupNameCell = ({groupName, groupClarifier}) => {
    if (groupName === 'REDACTED') {
        return <RedactedName>Anonymous</RedactedName>;
    }

    return (<NameCell>
        <GroupingNameCell left>
            {groupName}
        </GroupingNameCell>
        <ClarifierCell subdued>
            {groupClarifier}
        </ClarifierCell>
    </NameCell>);
};

export default GroupNameCell